import { ProductAccessoriesActionState } from "@/app/blu/shop/actions";

export const ConfiguratorAccessoriesNotFound = ({
  response,
}: ConfiguratorAccessoriesNotFoundProps) => {
  return (
    <section data-testid="configurator-accessories-not-found">
      No results found for "{response.search}".
    </section>
  );
};

export type ConfiguratorAccessoriesNotFoundProps = {
  response: ProductAccessoriesActionState;
};
